import { render, staticRenderFns } from "./addgoodsNotice.vue?vue&type=template&id=1806cdf2"
import script from "./addgoodsNotice.vue?vue&type=script&lang=js"
export * from "./addgoodsNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports